import { registerActions } from '@/lib/actions';
import { registerCommands, registerView } from '@/lib/slots';
import type { ClientArea } from '../types';

// People and Companies: the two spreadsheet lists, creating records, merging duplicates, and what the team offers
// with the capabilities and markets companies are grouped by.

export const area: ClientArea = {
  name: 'records',
  setup() {
    registerView('people', () => import('./PeopleView'));
    registerView('companies', () => import('./CompaniesView'));
    registerActions({
      newRecord: (type, init) => void import('./NewRecordDialog').then((m) => m.openNewRecord(type, init)),
      merge: (type, ids) => void import('./MergeDialog').then((m) => m.openMergeDialog(type, ids)),
      restoreDuplicates: (type, refused) => void import('./RestoreDuplicates').then((m) => m.openRestoreDuplicates(type, refused)),
      profileTerms: (section) => void import('./ProfileTermsDialog').then((m) => m.openProfileTerms(section)),
    });
    registerCommands(() => [
      {
        id: 'records.new-person',
        title: 'New person',
        sub: 'Add someone to People',
        icon: 'user-plus',
        keywords: 'add person contact create people',
        order: 95,
        run: () => void import('./NewRecordDialog').then((m) => m.openNewRecord('person')),
      },
      {
        id: 'records.new-company',
        title: 'New company',
        sub: 'Add a company to Companies',
        icon: 'building',
        keywords: 'add company organisation organization account create',
        order: 96,
        run: () => void import('./NewRecordDialog').then((m) => m.openNewRecord('company')),
      },
      {
        id: 'records.offerings',
        title: 'What we offer',
        sub: 'Your team’s capabilities, matched to company gaps',
        icon: 'target',
        keywords: 'offer offering services capabilities strengths gaps markets profile fit',
        order: 126,
        run: () => void import('./ProfileTermsDialog').then((m) => m.openProfileTerms('offerings')),
      },
    ]);
  },
};
